import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ComisionesLayOut } from 'src/app/model/commission-layout/comisiones-layout';
import { ComisionesLayOutEnvio } from 'src/app/model/commission-layout/comisiones-layout-envio';
import { CommissionLayoutService } from 'src/app/services/commission-layout.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-comisiones-envio',
  templateUrl: './comisiones-envio.component.html',
  styleUrls: ['./comisiones-envio.component.css']
})
export class ComisionesEnvioComponent implements OnInit {

  // Controladores de la pagina
  viewStatus: number = 0;
  documentVoBo: boolean = false; // Controla si el documento tiene VoBo
  actualizarCifrasControl: boolean = false; 

  // Variables
  documento: ComisionesLayOut | null = null;
  idDocumento: string | null = null;
  statusDocumento: number | null = null;
  cifrasControlOriginal: any | null = null;
  documentName: String | null = null;
  fechaInicio: string | null = null;
  fechaFin: string | null = null;
  cifrasControl: any | null = null;
  sendResponse: boolean = false;
  fechaEnvio: string | null = null;
  sendEmail: boolean = false;

  // Arreglo para almacenar las tablas leídas del excel
  columnas: string[] = [ // Como esta la variable
    'idComisionesLayOutEnvio', 'status', 'observaciones', 'mes', 'venta', 'pago', 'distribuidor', 'tipoComision', 'idEmpleado', 'nombreEmpleado', 'direccion', 'entidad', 'sucursal', 'departamento', 'puesto', 'colocacion', 'montoComision', 'idCredito', 'colectivo', 'folio', 'producto'
  ];
  headers: string[] = [ // Como se va a ver en el FRONT
    'ID', 'Status', 'Observaciones', 'Mes', 'Venta', 'Pago', 'Distribuidor', 'Tipo de Comisión', 'ID Empleado', 'Nombre del Empleado', 'Dirección', 'Entidad', 'Sucursal', 'Departamento', 'Puesto', 'Colocación', 'Monto de Comisión', 'ID Crédito', 'Colectivo', 'Folio', 'Producto'
  ];
  comissionsTables: { nombre: string, headers: string[], columnas: string[], datos: any[] }[] = [];
  selectedTabIndex: number | null = null;

  // Opciones de configuración de las tablas
  dtOptions = {};

  constructor(private route: ActivatedRoute,
    private commissionLayoutService: CommissionLayoutService
  ) {}

  ngOnInit() {
    this.dtOptions = {
      responsive: true,
      autoWidth: false,
      select: "single",
      bLengthChange: true,
      searching: true,
      dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: [],
      pagingType: "full_numbers",
      paging: true,
      pageLength: 25,
      language: {
        processing: "Procesando...",
        search: "Buscar:",
        lengthMenu: "Mostrar _MENU_ elementos",
        info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
        infoEmpty: "Mostrando ningún elemento.",
        infoFiltered: "(filtrado _MAX_ elementos total)",
        infoPostFix: "",
        loadingRecords: "Cargando registros...",
        zeroRecords: "No se encontraron registros",
        emptyTable: "No hay datos disponibles en la tabla",
        paginate: {
          first: "Primero",
          previous: "Anterior",
          next: "Siguiente",
          last: "Último",
        },
        aria: {
          sortAscending: ": Activar para ordenar la tabla en orden ascendente",
          sortDescending: ": Activar para ordenar la tabla en orden descendente",
        },
      },
    };

    this.idDocumento = this.route.snapshot.paramMap.get('id');
    console.log('ID del documento:', this.idDocumento);

    this.getDocument();
  }

  getDocument(){
    this.commissionLayoutService.getDocumentById(this.idDocumento).subscribe(
      (response: ComisionesLayOut) => {
        this.documento = response;
        this.getDocumentEnvios();
      },
      (error) => {
        console.error('Error al obtener el documento:', error);
      }
    );
  }
  
  getDocumentEnvios(){
    this.commissionLayoutService.getDocumentEnviosByLayOutId(this.idDocumento).subscribe(
      (response: ComisionesLayOutEnvio[]) => {
        this.documento.comisionesLayOutEnvios = response;
        console.log('Documento: ', this.documento);
        this.setVariables();
      },
      (error) => {
        console.error('Error al obtener los envíos del documento:', error);
      }
    );
  }

  setVariables() {
    this.statusDocumento = this.documento.status;
    this.fechaEnvio = this.documento.sendDate;
    if(this.statusDocumento){
      this.documentVoBo = this.statusDocumento === 1; // Si el status es 1 (Enviado), tiene VoBo
    }
    this.documentName = this.documento.nombreDocumento.substring(0, this.documento.nombreDocumento.lastIndexOf('.'));
    this.fechaInicio = this.documento.fechaInicial;
    this.fechaFin = this.documento.fechaFinal;

    let data = this.documento.comisionesLayOutEnvios.map(envio => ({
      idComisionesLayOutEnvio: envio.idComisionesLayOutEnvio,
      fila: envio.fila,
      status: this.statusDocumento === 1 ? envio.status : 1,
      statusDescripcion: this.statusDocumento === 1 ? envio.statusDescripcion : 'VALIDADO',
      mes: envio.mes,
      venta: envio.venta,
      pago: envio.pago,
      idEmpresa: envio.idEmpresa,
      distribuidor: envio.distribuidor,
      tipoComision: envio.tipoComision,
      idEmpleado: envio.idEmpleado,
      nombreEmpleado: envio.nombreEmpleado,
      direccion: envio.direccion,
      entidad: envio.entidad,
      sucursal: envio.sucursal,
      departamento: envio.departamento,
      puesto: envio.puesto,
      colocacion: envio.colocacion,
      montoComision: envio.montoComision,
      idCredito: envio.idCredito,
      colectivo: envio.colectivo,
      folio: envio.folio,
      producto: envio.producto,
      observaciones: envio.observaciones
    }));
    this.comissionsTables = [{
      nombre: "Envíos",
      headers: this.headers,
      columnas: this.columnas,
      datos: data
    }];

    this.onTabChange(0);
    this.calcularCifrasControl();
    this.cifrasControlOriginal = {
      total: this.documento.totalPagosUp,
      validados: this.documento.pagosValidadosUp,
      rechazados: this.documento.pagosRechazadosUp,
      retenciones: this.documento.pagosRetenidosUp,
      colocacion: this.documento.capitalUp,
      comisiones: this.documento.comisionesUp
    };
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
    this.updateWithDelay('viewStatus', 0, 1);
  }

  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async updateWithDelay(variable: string, firstValue: any, secondValue: any) {
    this[variable] = firstValue;
    await this.delay(100);
    this[variable] = secondValue;
    await this.delay(100);
  }

  otorgarVoBo() {
    const allRows = this.comissionsTables.reduce((acc, tabla) => acc.concat(tabla.datos), []);
    console.log(allRows);
    const allValidatedOrRejected = allRows.every(row => row.status !== 0);
    if (!allValidatedOrRejected) {
      Swal.fire({
        icon: 'warning',
        title: 'Validación incompleta',
        text: 'Aun existen comisiones PENDIENTES, revisa antes de continuar.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    Swal.fire({
      title: '¿Otorgar VoBo?',
      text: '¿Está seguro de que desea otorgar VoBo al documento?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, otorgar VoBo',
      cancelButtonText: 'Rechazar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: 'success',
          title: 'VoBo otorgado',
          text: 'El documento ha sido validado correctamente.',
          confirmButtonText: 'Aceptar'
        });
        this.documentVoBo = true;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.documentVoBo = false;
      }
    });
  }

  onStatusChange(row: any, tabIndex: number) {
    const tabla = this.comissionsTables[tabIndex];
    const fila = tabla.datos.find((r: any) => r.idComisionesLayOutEnvio === row.idComisionesLayOutEnvio);
    if (fila) {
      fila.status = row.status;
    }
    this.calcularCifrasControl();
  }

  private calcularCifrasControl() {
    const allRows = this.comissionsTables.reduce((acc, tabla) => acc.concat(tabla.datos), []);
    //const total = allRows.length;
    const validados = allRows.filter(row => row.status === 1).length;
    const retenidos = allRows.filter(row => row.status === 2).length;
    const rechazados = allRows.filter(row => row.status === 3).length;

    const rowsValidos = allRows.filter(row => row.status !== 3);
    const sumaColocacion = rowsValidos.reduce((sum, row) => sum + (row.colocacion || 0), 0);
    const sumaComisiones = rowsValidos.reduce((sum, row) => sum + (row.montoComision || 0), 0);

    this.cifrasControl = {
      total: rowsValidos.length,
      validados: validados,
      rechazados: rechazados,
      retenciones: retenidos,
      colocacion: Number(sumaColocacion.toFixed(2)),
      comisiones: Number(sumaComisiones.toFixed(2))
    };

    this.updateWithDelay('viewStatus', 0, 1);

    console.log('Cifras de control:', this.cifrasControl);
  }

  public formatNumber(value: number): string {
    return value.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  public formatMoney(value: number, currency: string = 'MXN'): string {
    if (isNaN(value)) {
      return '0.00';
    }
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  enviarComisiones() {
    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire({
        icon: 'warning',
        title: 'Fechas requeridas',
        text: 'Debe ingresar la fecha de inicio y fin antes de cargar las comisiones.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    
    if (this.fechaFin < this.fechaInicio) {
      Swal.fire({
        icon: 'warning',
        title: 'Fechas inconsistentes',
        text: 'La fecha de fin no puede ser anterior a la fecha de inicio.',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    if (this.documentVoBo) {
      // Lógica para cargar las comisiones
      console.log('Cifras control:', this.cifrasControl);
      console.log('UserId:', localStorage.getItem('UserId'));
      console.log('Role:', localStorage.getItem('role'));

      // Construir objetos para el Back
      let comisionesLayOut: ComisionesLayOut = this.getComisionesLayOut();
      console.log('Comisiones LayOut:', comisionesLayOut);

      // Mostrar indicador de carga
      Swal.fire({
        title: 'Procesando...',
        text: 'Procesando las comisiones cargadas',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Ejecutar el primer servicio (enviar comisiones)
      this.commissionLayoutService.sendCommissionLayOut(comisionesLayOut).subscribe({
        next: (response: ComisionesLayOut) => {
          console.log('Respuesta del servidor (sendCommissionLayOut):', response);

          // Actualizar texto del loading para mostrar progreso
          Swal.update({
            title: 'Procesando...',
            text: 'Enviando correo electrónico...',
            allowOutsideClick: false,
            showConfirmButton: false,
            showCancelButton: false
          });
          // Mantener el loading spinner
          Swal.showLoading();

          // Crear el reporte Excel
          const wb = this.crearReporte(true);
          const excelBuffer: ArrayBuffer = XLSX.write(wb, {
            bookType: 'xlsx',
            type: 'array'
          });

          // Convertir a Blob
          const excelBlob: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          // Preparar FormData
          const formData = new FormData();
          formData.append('documentos', excelBlob);
          formData.append('idComisionesLayOut', comisionesLayOut.idComisionesLayOut.toString());
          formData.append('fechaCobro', comisionesLayOut.fechaInicial.toString());
          formData.append('fechaEnvio', new Date().toISOString().split('T')[0]);
          formData.append('numeroRegistros', comisionesLayOut.totalPagosSend.toString());
          formData.append('importeColocacion', comisionesLayOut.capitalSend.toString());
          formData.append('importeComisiones', comisionesLayOut.comisionesSend.toString());

          // Ejecutar el segundo servicio (enviar correo)
          this.commissionLayoutService.sendEmailComisionesLayOutEnvio(formData).subscribe({
            next: (emailResponse) => {
              console.log('Respuesta del servidor (sendEmail):', emailResponse);

              // CERRAR el loading AQUÍ cuando todo haya terminado exitosamente
              Swal.close();

              // Mostrar mensaje de éxito
              Swal.fire({
                icon: 'success',
                title: 'Comisiones enviadas',
                text: 'Las comisiones se han cargado correctamente y se han enviado via correo electrónico',
                confirmButtonText: 'Aceptar'
              });

              this.sendEmail = true;
              this.statusDocumento = 1;
              this.sendResponse = true;
              this.fechaEnvio = response.sendDate;
            },
            error: (emailError) => {
              console.error('Error al enviar correo electrónico:', emailError);

              // CERRAR el loading AQUÍ en caso de error en el envío de correo
              Swal.close();

              Swal.fire({
                icon: 'error',
                title: 'Error al enviar correo electrónico',
                text: 'Las comisiones se han cargado correctamente, pero ocurrió un error al enviar el correo electrónico.',
                confirmButtonText: 'Aceptar'
              });

              this.sendEmail = false;
              this.sendResponse = true;
              this.fechaEnvio = response.sendDate;
            }
          });
        },
        error: (error) => {
          console.error('Error al guardar Comisiones LayOut:', error);

          // CERRAR el loading AQUÍ en caso de error en el primer servicio
          Swal.close();

          Swal.fire({
            icon: 'error',
            title: 'Error al cargar comisiones',
            text: 'Ocurrió un error al cargar las comisiones. Por favor, inténtelo de nuevo más tarde.',
            confirmButtonText: 'Aceptar'
          });
        }
      });

    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Cargar Comisiones',
        text: 'Debe otorgar VoBo al documento antes de enviar a pago las comisiones.',
        confirmButtonText: 'Aceptar'
      });
    }
  }

  getComisionesLayOut(){
    // Construir objetos para el Back
    console.log(this.comissionsTables[0].datos);
    const comisionesLayOutEnvios: ComisionesLayOutEnvio[] = this.comissionsTables[0].datos.map(row => ({
      idComisionesLayOutEnvio: row.idComisionesLayOutEnvio,
      fila: row.fila,
      status: row.status,
      statusDescripcion: row.status === 0 ? 'PENDIENTE' : row.status === 1 ? 'VALIDADO' : row.status === 2 ? 'RETENIDO' : 'RECHAZADO',
      mes: row.mes,
      venta: row.venta,
      pago: row.pago,
      idEmpresa: row.idEmpresa,
      distribuidor: row.distribuidor,
      tipoComision: row.tipoComision,
      idEmpleado: row.idEmpleado,
      nombreEmpleado: row.nombreEmpleado,
      direccion: row.direccion,
      entidad: row.entidad,
      sucursal: row.sucursal,
      departamento: row.departamento,
      puesto: row.puesto,
      colocacion: row.colocacion,
      montoComision: row.montoComision,
      idCredito: row.idCredito,
      colectivo: row.colectivo,
      folio: row.folio,
      producto: row.producto,
      observaciones: row.observaciones
    }));
    console.log('Comisiones LayOut Envios:', comisionesLayOutEnvios);

    // Construir objetos para el Back
    const comisionesLayOut: ComisionesLayOut = {
      idComisionesLayOut: this.documento.idComisionesLayOut,
      nombreDocumento: this.documento.nombreDocumento,
      fechaInicial: this.documento.fechaInicial,
      fechaFinal: this.documento.fechaFinal,
      status: this.documento.status,
      statusDescripcion: this.documento.status == 0 ? 'PENDIENTE' : 'ENVIADO',
      totalPagosUp: this.documento.totalPagosUp,
      pagosValidadosUp: this.documento.pagosValidadosUp,
      pagosRetenidosUp: this.documento.pagosRetenidosUp,
      pagosRechazadosUp: this.documento.pagosRechazadosUp,
      capitalUp: this.documento.capitalUp,
      comisionesUp: this.documento.comisionesUp,
      totalPagosSend: this.cifrasControl.total,
      pagosValidadosSend: this.cifrasControl.validados,
      pagosRetenidosSend: this.cifrasControl.retenciones,
      pagosRechazadosSend: this.cifrasControl.rechazados,
      capitalSend: this.cifrasControl.colocacion,
      comisionesSend: this.cifrasControl.comisiones,
      createUser: this.documento.createUser,
      createDate: this.documento.createDate,
      sendUser: localStorage.getItem('UserId') || 'unknown',
      sendDate: null,
      typeCommissionDocument: this.documento.typeCommissionDocument,
      comisionesLayOutCargas: [],
      comisionesLayOutEnvios: comisionesLayOutEnvios
    };

    return comisionesLayOut;
  }

  descargarReporte() {
    const wb = this.crearReporte();

    // Descargar Excel con todas las hojas
    XLSX.writeFile(wb, `${this.comissionsTables[0].nombre}.xlsx`);
  }

  crearReporte(docValidado: boolean = true): XLSX.WorkBook {
    if (!this.comissionsTables || this.comissionsTables.length === 0) return;

    // Crear workbook
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    this.comissionsTables.forEach((tabla, index) => {
      const emailHeaders = ['Mes', 'Venta', 'Pago', 'Distribuidor', 'Tipo de Comisión', 'ID Empleado', 'Nombre del Empleado', 'Dirección', 'Entidad', 'Sucursal', 'Departamento', 'Puesto', 'Colocación', 'Monto de Comisión', 'Status'];
      const emailColumns = ['mes', 'venta', 'pago', 'distribuidor', 'tipoComision', 'idEmpleado', 'nombreEmpleado', 'direccion', 'entidad', 'sucursal', 'departamento', 'puesto', 'colocacion', 'montoComision', 'status'];
      
      const headers = docValidado 
        ? emailHeaders.filter(header => tabla.headers.includes(header)) // Mantener orden de emailHeaders
        : tabla.headers; // Orden original si no es docValidado
      
      const columnas = docValidado
        ? emailColumns.filter((columna, index) => emailHeaders[index] && tabla.headers.includes(emailHeaders[index])) // Mantener correspondencia
        : tabla.columnas; // Orden original si no es docValidado

      const ws_data: any[][] = [];
      const numCols = headers.length;

      // Primera fila: nombre de la opción (mergeado en todas las columnas)
      const firstRow = Array(numCols).fill('');
      firstRow[0] = tabla.nombre;
      ws_data.push(firstRow);

      // Segunda fila: headers
      ws_data.push(headers);

      // Filas de datos
      tabla.datos
        .filter(row => !docValidado || docValidado && row.status !== 3)
        .forEach(row => {
          const fila: any[] = [];
          
          // Mapear cada header con su columna correspondiente
          headers.forEach(header => {
            // Encontrar el índice del header en emailHeaders para obtener la columna correcta
            const headerIndex = !docValidado ? headers.indexOf(header) : emailHeaders.indexOf(header);
            let columna;
            if(!docValidado) {
              columna = headerIndex !== -1 ? columnas[headerIndex] : null;
            } else {
              columna = headerIndex !== -1 ? emailColumns[headerIndex] : null;
            }

            if (columna && columna === 'status') {
              // 0 - Pendiente, 1 - Validado, 2 - Retenido, 3 - Rechazado
              let statusLabel = row[columna] == 2 ? 'Retenido' : '';
              if (!docValidado) {
                switch (row[columna]) {
                  case 0:
                    statusLabel = 'Pendiente';
                    break;
                  case 1:
                    statusLabel = 'Validado';
                    break;
                  case 2:
                    statusLabel = 'Retenido';
                    break;
                  case 3:
                    statusLabel = 'Rechazado';
                    break;
                  default:
                    statusLabel = 'Desconocido';
                }
              }
              fila.push(statusLabel);
            } else if (columna && (columna === 'venta' || columna === 'pago')) {
              const formattedDate = this.convertirFecha(row[columna]);
              fila.push(formattedDate);
            } else if (columna) {
              // Solo agregar si la columna existe
              fila.push(row[columna]);
            }
          });
          
          ws_data.push(fila);
        });

      // Crear worksheet
      const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(ws_data);

      // Combinar la primera fila
      ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } }];

      // Ajustar ancho de columnas
      ws['!cols'] = headers.map(h => ({ wch: Math.max(h.length, 15) }));

      // Agregar hoja al libro (nombre dinámico por cada tabla)
      const sheetName = tabla.nombre || `Hoja${index + 1}`;
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });

    return wb;
  }

  editarObservacion(row: any, tabIndex: number) {
    Swal.fire({
      title: 'Editar Observación',
      input: 'text',
      inputLabel: 'Observación',
      inputValue: row.observaciones || '',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (value && value.length > 200) {
          return 'La observación no puede exceder los 200 caracteres.';
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        row.observaciones = result.value;
        const tabla = this.comissionsTables[tabIndex];
        const fila = tabla.datos.find((r: any) => r.idComisionesLayOutEnvio === row.idComisionesLayOutEnvio);
        if (fila) {
          fila.observaciones = row.observaciones;
        }
        Swal.fire({
          icon: 'success',
          title: 'Observación actualizada',
          text: 'La observación ha sido guardada correctamente.',
          confirmButtonText: 'Aceptar'
        });
      }
    });

  }

  retirarVoBo(){
    this.documentVoBo = false;
  }

  reenviarCorreo() {
    // Mostrar loading
    Swal.fire({
      title: 'Enviando...',
      text: 'Enviando comisiones',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Preparar datos (sin setTimeout innecesario)
    const comisionesLayOut: ComisionesLayOut = this.getComisionesLayOut();

    const wb = this.crearReporte(true);
    const excelBuffer: ArrayBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const excelBlob: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const formData = new FormData();
    formData.append('documentos', excelBlob);
    formData.append('idComisionesLayOut', comisionesLayOut.idComisionesLayOut.toString());
    formData.append('fechaCobro', comisionesLayOut.fechaInicial.toString());
    formData.append('fechaEnvio', new Date().toISOString());
    formData.append('numeroRegistros', comisionesLayOut.totalPagosUp.toString());
    formData.append('importeColocacion', comisionesLayOut.capitalUp.toString());
    formData.append('importeComisiones', comisionesLayOut.comisionesUp.toString());

    // Ejecutar el servicio y cerrar loading solo cuando termine
    this.commissionLayoutService.sendEmailComisionesLayOutEnvio(formData).subscribe({
      next: (response) => {
        console.log('Respuesta del servidor:', response);
        
        // CERRAR el loading AQUÍ cuando el servicio termine exitosamente
        Swal.close();
        
        // Mostrar mensaje de éxito
        Swal.fire({
          icon: 'success',
          title: 'Comisiones enviadas',
          text: 'Se han enviado via correo electrónico',
          confirmButtonText: 'Aceptar'
        });
        
        this.sendEmail = true;
        this.statusDocumento = 1;
      },
      error: (error) => {
        console.error('Error al enviar correo electrónico:', error);
        
        // CERRAR el loading AQUÍ en caso de error
        Swal.close();
        
        Swal.fire({
          icon: 'error',
          title: 'Error al enviar correo electrónico',
          text: 'Ocurrió un error al enviar el correo electrónico.',
          confirmButtonText: 'Aceptar'
        });
        
        this.sendEmail = false;
      }
    });
  }

  convertirFecha(fecha: string): string {
    // Validar que no sea null, undefined o vacío
    if (!fecha || typeof fecha !== 'string') {
      return '';
    }

    // Validar formato AAAA-MM-DD con regex
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(fecha)) {
      return '';
    }

    // Validar que sea una fecha válida
    const date = new Date(fecha + 'T00:00:00');
    if (isNaN(date.getTime())) {
      return '';
    }
    
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const año = date.getFullYear();
    return `${dia}/${mes}/${año}`;
  }
  
}